export default function FrontendMiniProjects(){
    return(
        <div>
            hello how are you today 
        </div>
    )
}